(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pv-scroll]');
    if (!btn) return;
    var rail = btn.closest('.pv-rail');
    var track = rail && rail.querySelector('[data-pv-track]');
    if (!track) return;
    var item = track.querySelector('.pv-rail__item');
    var step = item ? item.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
    track.scrollBy({ left: btn.dataset.pvScroll === 'next' ? step : -step, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
